/**
 * Created by rorschach on 2018/5/29.
 */

// antd-mobile全局通用样式
import "antd-mobile/lib/style";
import Toast from "./src/toast";
import NavBar from "./src/nav-bar";

// ----------------------------------------------------

// 这里必须以下方式import, 直接 import {} from 'antd-mobile' 外部找不到



//ant-mobile

import Tabs from "antd-mobile/lib/tabs";
import "antd-mobile/lib/tabs/style";

import Popover from "antd-mobile/lib/popover";
import "antd-mobile/lib/popover/style";

import SearchBar from "antd-mobile/lib/search-bar";
import "antd-mobile/lib/search-bar/style";

import WingBlank from "antd-mobile/lib/wing-blank";
import "antd-mobile/lib/wing-blank/style";

import InputItem from "antd-mobile/lib/input-item";
import "antd-mobile/lib/input-item/style";

import TextareaItem from "antd-mobile/lib/textarea-item";
import "antd-mobile/lib/textarea-item/style";

import List from "antd-mobile/lib/list";
import "antd-mobile/lib/list/style";

import ListView from "antd-mobile/lib/list-view";
import "antd-mobile/lib/list-view/style";

import Modal from "antd-mobile/lib/modal";
import "antd-mobile/lib/modal/style";

import Carousel from "antd-mobile/lib/carousel";
import "antd-mobile/lib/carousel/style";

import ActivityIndicator from "antd-mobile/lib/activity-indicator";
import "antd-mobile/lib/activity-indicator/style";




export {
  WingBlank,
  SearchBar,
  ListView,
  Modal,
  Toast,
  List,
  NavBar,
  ActivityIndicator,
  Tabs,
  Carousel,
  InputItem,
  TextareaItem,
  Popover
};



// WEBPACK FOOTER //
// ./src/xyui/index.js